import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_KHARADRON_OVERLORDS: {
    name: 'Battletome: Kharadron Overlords',
    type: 'battletome',
  },
  ERRATA_JANUARY_2021: {
    name: 'Errata (January 2021)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2018/06/oyysZxiLF19anAc7.pdf',
  },
  ERRATA_JULY_2021: {
    name: 'Errata (July 2021)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2018/06/T6LNSIDslUOTB0Ho.pdf',
  },
  ERRATA_AUGUST_2021: {
    name: 'Errata (August 2021)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2018/06/mnIpUNP536ZDzhzq.pdf',
  },
  WHITE_DWARF_MAY_2022: {
    name: 'White Dwarf (May 2022)',
    type: 'white_dwarf',
  },
  ERRATA_JULY_2022: {
    name: 'Errata (July 2022)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2018/06/yZSgwuU45O72wNtB.pdf',
  },
  ERRATA_OCTOBER_2022: {
    name: 'Errata (October 2022)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2018/06/L1l9ZHIAyq7tBRbT.pdf',
  },
  ERRATA_JANUARY_2023: {
    name: 'Errata (January 2023)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2018/06/X56aKSIwkch6qyi9.pdf',
  },
  ERRATA_MARCH_2023: {
    name: 'Errata (March 2023)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2023/03/ww7V9OeWxIUgjNtI.pdf',
  },
} satisfies TRuleSources

export default rule_sources
